import { styled } from '@silverstein-properties/inspirelabs-ui';

export const StyledImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius,
}));
